
import TableList from "@components/templates/tablelist";
import compUpdate from "./update.vue";
import {
    HttpLogiticMeasureList,
    HttpActiveLogiticMeasure
} from "@/service/carrieraccount.js";
import { mapState, mapGetters } from "vuex";
export default {
    mixins: [TableList],
    components: {
        compUpdate,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 100,
            },
            carrierServiceList: [],
            datename: '',
            datetime: '',
            Plugins: { show: true },
            initData: '',
        };
    },
    methods: {
        ajaxRequest: HttpLogiticMeasureList,
        exportQuery() {
            let searchData = {}
            Object.keys(this.formData.search).map(item => {
                console.log(item, this.formData.search[item])
                searchData[`search[${item}]`] = this.formData.search[item]
            });
            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/carrierCalculate/batchExport", {
                ...searchData
            }, {
                executor: 'request',
                download: true,
            }).catch(err => {
                // this.$VMessage.error(err.message);
            });
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.selectdata', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'exportQuery':
                    this.exportQuery(params);
                    break;
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 800,
                        component: "compUpdate",
                        activeid: params.activeid,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case 'add':
                    this.operate = {
                        title: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'add',
                        showFooter: false
                    }
                    break;
                case 'changeStatus':
                    this.operate = {
                        title: params.isCalculate === 0 ? this.$t('fbb.accountmanage.loss_effect', { defaultValue: '失效' }) : this.$t('fbb.accountmanage.active', { defaultValue: '启用' }),
                        show: true,
                        alert: 'warning',
                        width: 400,
                        showDesc: true,
                        params: {
                            id: params.id
                        },
                        ajaxRequest: HttpActiveLogiticMeasure,
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: true,
                    params: {
                        activeid: id
                    },
                    operate: 'query'
                },
                {
                    label: row.isCalculate === 0 ? this.$t('fbb.accountmanage.loss_effect', { defaultValue: '失效' }) : this.$t('fbb.accountmanage.active', { defaultValue: '启用' }),
                    show: this.handleAuth('fbb.calculateservice.edit'),
                    params: {
                        id,
                        isCalculate: row.isCalculate
                    },
                    operate: 'changeStatus'
                }
            ]
        },
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAllList",
            "getBillcusWareList",
            "getCarrierServiceList"
        ]),
        ToolsData() {
            return [
                {
                    name: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    operate: "add",
                    show: this.handleAuth('fbb.calculateservice.add'),
                    theme: "primary",
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'exportQuery',
                    show: this.handleAuth('fbb.calculateservice.export'),
                    theme: 'success'
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.expresspackage.service_code', { defaultValue: '承运商' }),
                    tag: 'Select',
                    show: true,
                    key: 'IN_carrierCode',
                    options: this.getCarrierAllList,
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    },
                },

                {
                    label: this.$t('erp.b2c.hippingMethodCode', { defaultValue: '物流服务' }),
                    tag: 'Input',
                    show: true,
                    key: 'CN_carrierServiceCode',
                },
                {
                    label: this.$t('', { defaultValue: '是否测算' }),
                    tag: 'Select',
                    show: true,
                    key: 'EQ_isCalculate',
                    options: [
                        { value: 0, label: this.$t('erp.global.yes', { defaultValue: '是' }) },
                        { value: 1, label: this.$t('erp.global.no', { defaultValue: '否' }) }
                    ]
                },
            ]
        },
        columns() {
            return [
                {
                    // show: false,
                    type: 'index',
                    width: 40,
                    align: 'center',
                }, {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                },
                {
                    title: this.$t('fbb.expresspackage.service_code', { defaultValue: '承运商' }),
                    key: 'carrierCode'
                },

                {
                    title: this.$t('erp.b2c.hippingMethodCode', { defaultValue: '物流服务' }),
                    key: 'carrierServiceCode',
                    render: (h, { row }) => {
                        return <div>{row.carrierServiceCode}({row.carrierServiceName})</div>
                    }
                },
                {
                    title: this.$t('', { defaultValue: '是否测算' }),
                    key: 'carrierGroupName',
                    render: (h, { row }) => {
                        return <div>{row.isCalculate == 0 ? this.$t('erp.global.yes', { defaultValue: '是' }) : this.$t('erp.global.no', { defaultValue: '否' })}</div>
                    }
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    // width: 130
                }
            ];
        },

    }

};
